<ng-container *ngIf="showMenubar()">
  <app-header (toggleSidenav)="onHeaderMenuToggle()"></app-header>
  <app-sidenav
    #sidenavRef
    (eventToggleSideNav)="onToggleSideNav($event)"
  ></app-sidenav>
  <div
    class="set-body-width"
    [ngClass]="{ collapsed: isOpened, opened: !isOpened }"
  >
    <app-body
      [collapsed]="isSideNavCollapsed"
      [screenWidth]="screenWidth"
    ></app-body>
  </div>
</ng-container>

<ng-container *ngIf="!showMenubar()">
  <router-outlet></router-outlet>
</ng-container>
<app-draggable-widget *ngIf="showWidget"></app-draggable-widget>
